import { Tabs } from 'antd';
import styled from 'styled-components';

export const DashboardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 40px 45px 8px;
  gap: 15px;
  flex-wrap: wrap;
  cursor: default;
`;

export const DashboardTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    height: 36px;
    width: 36px;
  }
`;

export const DashboardTitle = styled.h2`
  margin: 0;
  color: #113e57;
  font-size: 32px;
  font-weight: 700;
`;

export const DashboardTabs = styled(Tabs)`
  &.ant-tabs .ant-tabs-nav {
    margin: 24px 45px;
    align-items: flex-end;
  }

  &.ant-tabs .ant-tabs-nav::before {
    border-bottom: none;
  }

  &.ant-tabs .ant-tabs-nav .ant-tabs-nav-list .ant-tabs-tab {
    margin: 0;
    padding: 18px 30px 16px 32px;
    font-size: 18px;
    font-weight: 400;
    color: #808080;
    transition: color 0.2s;
  }

  &.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn {
    color: inherit;
  }

  &.ant-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: #005d98;
  }

  &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #005d98;
    font-weight: 700;
  }

  &.ant-tabs .ant-tabs-nav .ant-tabs-ink-bar {
    height: 4px;
    background: #113e57;
  }
`;

export const AlertsHistoryTable = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 45px;

  & .ant-table-tbody > tr > td:first-child {
    border-left: 8px solid #9747ff;
    border-radius: 8px;
  }
`;
